function game_103()
{

}

game_103.odd_map  = {
  "9":[0,0,100,400,1000],
  "8":[0,0,50,200,400],
  "7":[0,0,20,50,300],
  "6":[0,0,20,50,300],
  "5":[0,0,10,20,250],
  "4":[0,0,10,20,200],
  "3":[0,0,5,15,150],
  "2":[0,0,5,10,100],
  "1":[0,0,5,10,100],
};

export {
  game_103
};



// WEBPACK FOOTER //
// ./src/components/slots/game_103.js